/**
 * Shared height for the two top-of-workspace bars: the chat sidebar header
 * (`ChatSidebar`) and the canvas top bar (`AppHeader`). They sit side by side,
 * so their bottom borders must line up — both use this fixed height instead
 * of sizing to content. Workplace post 1640407807716516.
 */
export const WORKSPACE_TOP_BAR_HEIGHT_CLASS = 'h-14'
